
<div *ngIf="isLoading" class="lse-loading-overlay">
  <div class="lse-spinner"></div>
</div>

<div
  *ngIf="eStatus"
>

  <div
    id="hr_wrapper"
    [ngClass]="{ hr_logos_top_spacer: mediaLib.panelOpen() }"
    class="hr_wrapper"
  >
  <div *ngIf="screenwidth <= 1023" class="hr_headline">
  <h1 class="h1">{{ eConfig?.title }}</h1>
  <h2 class="h2">{{ eConfig?.subtitle }}</h2>
</div>
    <div
      *ngIf="screenwidth > 1023"
      class="hr_grid ui grid content_header"
    >
      <div class="row row_contentheader">
        <div class="seven wide column hr_headline left_side_margin_top">
          <h1 class="h1">{{ eConfig?.title }}</h1>
          <h2 class="h2">{{ eConfig?.subtitle }}</h2>
        </div>
        <div class="two wide column"></div>
        <div class="seven wide column">
          <!-- Post-Live VOD Controls-->
          <div
            class="vod_buttons"
            *ngIf="
              ((eStatus.user_ask_questions || eStatus.user_see_questions) && eStatus.slides && (eStatus.player || eStatus.phase === 'live')) ||
                pollTabAvailable();
              else vod_buttons_placeholder
            "
          >
            <span
              [ngClass]="{ vod_buttons_switch_clicked: showSlides && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides && eStatus.user_ask_questions && eStatus.phase === 'post-live') ||
                (eStatus.phase === 'live' && eStatus.slides && eStatus.user_see_questions) ||
                slidesTabForPolls()
              "
              class="btn_switch_left"
            ></span>
            <input
              [ngClass]="{ vod_buttons_switch_clicked: showSlides && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides && eStatus.user_ask_questions && eStatus.phase === 'post-live') ||
                (eStatus.phase === 'live' && eStatus.slides && eStatus.user_see_questions) ||
                slidesTabForPolls()
              "
              type="button"
              class="vod_buttons_switch btn_show_presentation"
              value="{{ eLangGlob?.translateBtnPresentation }}"
              (click)="showElement('slides')"
            />
            <span
              [ngClass]="{ vod_buttons_switch_clicked: showSlides && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides && eStatus.user_ask_questions && eStatus.phase === 'post-live') ||
                (eStatus.phase === 'live' && eStatus.slides && eStatus.user_see_questions) ||
                slidesTabForPolls()
              "
              class="btn_switch_right"
            ></span>
            <span
              [ngClass]="{ vod_buttons_switch_clicked: showQuestions && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides && eStatus.user_ask_questions && eStatus.phase === 'post-live') ||
                (eStatus.phase === 'live' && eStatus.slides && eStatus.user_see_questions) ||
                questionsTabForPolls()
              "
              class="btn_switch_left"
            ></span>
            <input
              type="button"
              [ngClass]="{ vod_buttons_switch_clicked: showQuestions && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides &&
                  eStatus.user_ask_questions &&
                  eStatus.phase === 'post-live' &&
                  (!eSetup?.questionOrChapter || eSetup?.questionOrChapter === undefined)) ||
                (eStatus.phase === 'live' &&
                  eStatus.slides &&
                  eStatus.user_see_questions &&
                  (!eSetup?.questionOrChapter || eSetup?.questionOrChapter === undefined)) ||
                (questionsTabForPolls() && !eSetup?.questionOrChapter)
              "
              class="vod_buttons_switch btn_show_questions"
              value="{{  eStatus.user_vote_questions &&  eStatus.phase === 'live' ? eLangGlob?.translateVote :eLangGlob?.translateQuestions}}"
              (click)="showElement('questions')"
            />
            <input
              type="button"
              [ngClass]="{ vod_buttons_switch_clicked: showQuestions && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides &&
                  eStatus.user_ask_questions &&
                  eStatus.phase === 'post-live' &&
                  eSetup?.questionOrChapter) ||
                (eStatus.phase === 'live' && eStatus.slides && eStatus.user_see_questions && eSetup?.questionOrChapter) ||
                (questionsTabForPolls() && eSetup?.questionOrChapter)
              "
              class="vod_buttons_switch btn_show_questions"
              value="{{ eLangGlob?.translateChapter }}"
              (click)="showElement('questions')"
            />

            <span
              [ngClass]="{ vod_buttons_switch_clicked: showQuestions && !pollsTabActive() }"
              *ngIf="
                (eStatus.slides && eStatus.user_ask_questions && eStatus.phase === 'post-live') ||
                (eStatus.phase === 'live' && eStatus.slides && eStatus.user_see_questions) ||
                questionsTabForPolls()
              "
              class="btn_switch_right"
            ></span>

            <!-- Umfrage-Tab: erscheint, sobald es eine Umfrage für Zuschauer gibt -->
            @if (pollTabAvailable()) {
              <span [ngClass]="{ vod_buttons_switch_clicked: pollsTabActive() }" class="btn_switch_left"></span>
              <span class="poll_tab">
                <input
                  type="button"
                  [ngClass]="{ vod_buttons_switch_clicked: pollsTabActive() }"
                  class="vod_buttons_switch btn_show_polls"
                  value="{{ eLangGlob?.translatePollTitle }}"
                  (click)="showElement('polls')"
                />
                @if (pollStore.hasUnvotedOpenPoll() && !pollsTabActive()) {
                  <span class="poll_tab_badge" [title]="eLangGlob?.translatePollNew"></span>
                }
              </span>
              <span [ngClass]="{ vod_buttons_switch_clicked: pollsTabActive() }" class="btn_switch_right"></span>
            }
          </div>
          <!-- Umfrage-Tab gewählt und mehrere Einträge: zwischen ihnen wechseln (an der Stelle der Fragen-Sortierung).
               Eine Kette ist ein Eintrag; ihre Fragen blättert man im Karussell. -->
          @if (pollsTabActive() && pollStore.items().length > 1) {
            <div class="poll_header_tabs" role="tablist">
              @for (item of pollStore.items(); track item.id) {
                <button
                  type="button"
                  role="tab"
                  class="poll_header_tab"
                  [class.active]="item.id === pollStore.displayedItem()?.id"
                  [attr.aria-selected]="item.id === pollStore.displayedItem()?.id"
                  [title]="pollItemTitle(item)"
                  (click)="pollStore.selectItem(item)"
                >
                  @if (pollItemOpen(item)) {
                    <span class="poll_header_livedot" aria-hidden="true"></span>
                  }
                  <span class="poll_header_tablabel">{{ pollItemLabel(item) }}</span>
                </button>
              }
            </div>
          }
          @if (this.showQuestions && !pollsTabActive() && this.eStatus.user_vote_questions && eStatus.phase ==='live' && qs.questionCount > 0){

          <div style="display: flex; justify-content: space-between;margin-top: 20px">

            <div class="defaultColor dropUp" (click)="showDropdownUserVoteQuestions = !showDropdownUserVoteQuestions"
                 (clickOutside)="showDropdownUserVoteQuestions =false"
               >
              <div style="display:flex">

              <div class="dropDownArrow" [ngClass]="{rotateDown: showDropdownUserVoteQuestions}" style="margin:0 12px 0 9px !important;"></div>
                <div>     {{ eLangGlob?.translateSortBy }} {{ listReorderService.sortBy === 'votes' ? eLangGlob?.translatePopular : eLangGlob?.translateLatest }}
                  @if(showDropdownUserVoteQuestions){
                    <div style="position: absolute; z-index: 100; background: #fff; padding: 2px 5px; border: 1px solid #ccc; border-radius: 5px; margin-top: 5px; box-shadow: 0 2px 5px rgba(0,0,0,0.15); top:31px; left: 24px">
                      <div style="display: flex; flex-direction: column;" [ngStyle]="{'flex-direction': listReorderService.sortBy === 'votes'  ? 'column-reverse' : 'column'}">
                      <div [ngClass]="{disabled:listReorderService.sortBy === 'votes' }" value="votes" (click)="resortUserVoteQuestions('votes')">{{ eLangGlob?.translatePopular }}</div>
                      <div [ngClass]="{disabled:listReorderService.sortBy === 'date' }"value="date" (click)="resortUserVoteQuestions('date')">{{ eLangGlob?.translateLatest }}</div>
                      </div>
                    </div>
                  }
                </div>


            </div>




            </div>
            <div style="display: flex; gap :20px">
            <span>{{qs.questionCount}} {{eLangGlob?.translateQuestionsFixed}}</span>
            <span>{{eLangGlob?.translateVoteNow}}</span>
            </div>
          </div>
          }
          <ng-template #vod_buttons_placeholder>
            <div class="vod_buttons"></div>
          </ng-template>
          <div
            class="vod_nav_questions"
            *ngIf="eStatus.phase === 'post-live' && eStatus.player"
          >
            <div [hidden]="!showQuestions">
              <div
                class="vod_nav_control"
                *ngIf="vodCount > +eSetup.vod_pageSize"
              >
                <div
                  class="vod_nav_buttons vod_nav_buttons_padding_left"
                  (click)="paginateVodList('minus')"
                >
                  <span class="arrowLeft"></span>

                  {{ eSetup.vod_pageSize }}
                </div>
                <span class="fragen1bis10">
                  <span *ngIf="!eSetup?.questionOrChapter || eSetup?.questionOrChapter === undefined">{{
                    eLangGlob?.translateQuestions
                  }}</span>
                  <span *ngIf="eSetup?.questionOrChapter">{{ eLangGlob?.translateChapter }}</span>

                  {{ vodList?.vodFrom }}
                  {{ eLangGlob?.translateTo }}
                  <span *ngIf="vodList?.vodTo < vodCount">{{ vodList?.vodTo }}</span>
                  <span *ngIf="vodList?.vodTo >= vodCount">{{ vodCount }}</span>
                </span>
                <div
                  class="vod_nav_buttons"
                  (click)="paginateVodList('plus')"
                >
                  {{ eSetup.vod_pageSize }}
                  <span class="arrowRight"></span>
                </div>
                <i
                  title="{{ eLangGlob?.translateSyncDesctiption }}"
                  *ngIf="vodList?.manualPageChange"
                  (click)="vodList.changeManualPageChangeFalse()"
                  class="sync alternate icon"
                ></i>
              </div>
            </div>
            <div [hidden]="!showQuestions">
              <span class="hr_questions_total">
                <span *ngIf="!eSetup?.questionOrChapter || eSetup?.questionOrChapter === undefined"
                  >{{ eLangGlob?.translateQuestions }}
                </span>
                <span *ngIf="eSetup?.questionOrChapter">{{ eLangGlob?.translateChapter }} </span>
                &nbsp;{{ eLangGlob?.translateTotal }}: {{ vodCount }}
              </span>
            </div>
          </div>
          <div
            class="hr_emergency"
            *ngIf="eStatus.phase !== 'post-live' && eStatus.emergencyPublish"
          >
            <!--Wenn Notfalltext--><span>{{ eEmergency }}</span>
          </div>
        </div>
      </div>
    </div>
    <ng-template #header_mobile>
      <div class="hr_headline">
        <h1 class="h1">{{ eConfig?.title }}</h1>
        <h2 class="h2">{{ eConfig?.subtitle }}</h2>
      </div>
    </ng-template>
    <div *ngIf="screenwidth <= 1023 && eStatus.phase !== 'post-live' && eStatus.emergencyPublish">
      <div class="hr_emergency_mobile">
        <!--Wenn Notfalltext--><span>{{ eEmergency }}</span>
      </div>
    </div>
    <div
      class="hr_grid ui stackable grid onlyPlayer"
      *ngIf="eStatus && pInit && !eStatus.slides && !eStatus.user_ask_questions"
    >
      <div class="fullPlayer">
        <lse-videoplayer
          [stream]="this.eStreamSrc"
          [eventFolder]="eventFolder"
          [hidden]="eStatus.phase == 'pre-live' || (eStatus.phase === 'post-live' && !eStatus.player)"
          [eStatus]="eStatus"
          #player
          [@inOutAnimation]
          [eLangGlob]="eLangGlob"
          [options]="{
            fluid: true,
            controls: true,
            autoplay: true,
            playbackRates: usePlaybackrates,
            liveui: true,
            poster: this.posterPic,
            sources: [{ src: eStream, type: 'application/x-mpegURL' }]
          }"
        ></lse-videoplayer>
        <div
          class="hr_wartediv"
          *ngIf="eStatus.phase == 'pre-live' || (eStatus.phase === 'post-live' && !eStatus.player)"
        >
          <h2
            *ngIf="eStatus.use_postlive_txt"
            class="hr_wartetext"
          >
            {{ eConfig.postlive_txt }}
          </h2>
          <h2
            *ngIf="!eStatus.use_postlive_txt"
            class="hr_wartetext"
          >
            {{ eConfig.waiting_txt }}
          </h2>
        </div>
      </div>

      <!-- UMFRAGEN: ohne Folien und Fragen gibt es keine rechte Spalte, daher unter dem Player -->
      <div class="hr_poll_only_player" *ngIf="eStatus.phase !== 'post-live' || pollStore.vodMode()">
        <lse-user-poll [eLangGlob]="eLangGlob"></lse-user-poll>
      </div>

      <!-- PODIUM -->
      <div class="hr_podium">
        <div
          (click)="togglePodium()"
          class="hr_collapsible_podium"
          *ngIf="eStatus.user_vote_questions || (screenwidth <= 1023 && eConfig.participants.length !== 0)"
        >
          <button
            type="button"
            class="hr_btn_collapsible"
          >
            <span
              [ngClass]="{
                active: this.showPodium == 'in'
              }"
              class="arrow"
            >
              <span></span>
              <span></span>
            </span>
            <span> {{ eLangGlob?.translateParticipants }}</span>
          </button>
        </div>
        <div
          class="hr_collapsed_podium"
          [@slideInOut]="showPodium"
          *ngIf="eConfig.participants.length !== 0"
        >
          <div
            [ngClass]="{
              margintop: eStatus.user_vote_questions && screenwidth <= 1023 && eConfig.participants.length !== 0
            }"
          >
            <ng-container *ngFor="let author of eConfig.participants">
              <h4>
                <span class="name">{{ author['name'] }}</span>
                <span *ngIf="screenwidth > 512 && author['function'] != ''; else podiumDelimiter">, </span>
                <span class="function">{{ author['function'] }}</span>
              </h4>
              <ng-template #podiumDelimiter>
                <span *ngIf="author['function'] != ''">,<br /></span>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <hr *ngIf="eStatus.user_vote_questions || (screenwidth <= 1023 && eConfig.participants.length !== 0)" />
      </div>
      <!-- PODIUM ENDE -->

    </div>

    <div
      class="hr_grid ui stackable grid"
      *ngIf="pInit && (eStatus.slides || eStatus.user_ask_questions) && isLoading == false"
    >
      <div class="row">
        <div class="left seven wide column">
          <!-- PLAYER -->
          <div class="box leftBox">
            <lse-videoplayer
              [stream]="this.eStreamSrc"
              [eventFolder]="eventFolder"
              [hidden]="eStatus.phase === 'pre-live' || (!eStatus.player && eStatus.phase === 'post-live')"
              [eStatus]="eStatus"
              #player
              [@inOutAnimation]
              [eLangGlob]="eLangGlob"
              [options]="{
                fluid: true,
                controls: true,
                autoplay: true,
                playbackRates: usePlaybackrates,
                liveui: true,
                poster: this.posterPic,
                sources: [{ src: eStream, type: 'application/x-mpegURL' }]
              }"
            ></lse-videoplayer>
            <div
              class="hr_wartediv"
              *ngIf="eStatus.phase === 'pre-live' || (!eStatus.player && eStatus.phase === 'post-live')"
            >
              <h2
                *ngIf="eStatus.use_postlive_txt"
                class="hr_wartetext"
              >
                {{ eConfig.postlive_txt }}
              </h2>
              <h2
                *ngIf="!eStatus.use_postlive_txt"
                class="hr_wartetext"
              >
                {{ eConfig.waiting_txt }}
              </h2>
            </div>
          </div>
          <!-- PLAYER ENDE -->
          <!-- PODIUM -->
          <div class="hr_podium">
            <div
              (click)="togglePodium()"
              class="hr_collapsible_podium"
              *ngIf="(eStatus.user_vote_questions && eConfig.participants.length !== 0)  || (screenwidth <= 1023 && eConfig.participants.length !== 0)"
            >
              <button
                type="button"
                class="hr_btn_collapsible"
              >
                <span
                  [ngClass]="{
                    active: this.showPodium == 'in'
                  }"
                  class="arrow"
                >
                  <span></span>
                  <span></span>
                </span>
                <span> {{ eLangGlob?.translateParticipants }}</span>
              </button>
            </div>
          </div>

              <div
            class="hr_collapsed_podium"
            [@slideInOut]="showPodium"
            *ngIf="eConfig.participants.length !== 0"
          >
            <div
              [ngClass]="{
                margintop: eStatus.user_vote_questions && screenwidth <= 1023 && eConfig.participants.length !== 0
              }"
            >
              <ng-container *ngFor="let author of eConfig.participants ; index as i">
                <h4 [ngStyle]="i === 0 ? { 'margin-top': '20px' } : {}">
                  <span class="name">{{ author['name'] }}</span>
                  <span *ngIf="screenwidth > 512 && author['function'] != ''; else podiumDelimiter">, </span>
                  <span class="function">{{ author['function'] }}</span>
                </h4>
                <ng-template #podiumDelimiter>
                  <span *ngIf="author['function'] != ''">,<br /></span>
                </ng-template>
              </ng-container>
            </div>
          </div>

          <hr *ngIf="eConfig.participants.length !== 0 && (eConfig.description_enabled || (screenwidth <= 1023 && eConfig.description_enabled !== true) || eStatus.user_vote_questions)" />
            <!-- PODIUM ENDE -->
          @if (eStatus.user_see_questions && screenwidth >1023){
            <lse-user-ask-question></lse-user-ask-question>
          }
            <!-- DESCRIPTION START -->
            <div class="hr_podium" style='margin-top: unset !important;' *ngIf="eConfig.description_enabled" >
              <div
                (click)="toggleEventDescription()"
                class="hr_collapsible_podium"
              >
                <button
                  type="button"
                  class="hr_btn_collapsible"
                >
                <span
                  [ngClass]="{
                    active: this.showEventDescription == 'in'
                  }"
                  class="arrow"
                >
                  <span></span>
                  <span></span>
                </span>
                  <span> {{ eLangGlob?.translateEventDescription }}</span>
                </button>
              </div>
            </div>
            <div
              class="hr_collapsed_podium"
              [@slideInOut]="showEventDescription"
              *ngIf="eConfig.description_enabled == true"
            >
              <div
                [ngClass]="{
                margintop: eConfig.description_enabled || (screenwidth <= 1023 && eConfig.description_enabled == true)
              }"
              >
                <lse-description
                  [description]="eConfig.description"
                >
                </lse-description>
              </div>
          </div>
          <hr *ngIf="eConfig.description_enabled  || (eConfig.description_enabled == true && screenwidth <= 1023)" />


          <!-- DESCRIPTION ENDE -->

          <!-- MOBILE DIE RESTLICHEN KOMPONENTEN -->
          <div *ngIf="screenwidth <= 1023">
            <div
              class="hr_slides_mobile"
              *ngIf="eStatus.slides"
            >
              <div
                class="hr_collapsible_slides"
                (click)="toggleSlideMobile()"
              >
                <button
                  type="button"
                  class="hr_btn_collapsible"
                >
                  <span
                    [ngClass]="{
                      active: this.showSlideMobile == 'in'
                    }"
                    class="arrow"
                  >
                    <span></span>
                    <span></span>
                  </span>
                  <span>{{ eLangGlob?.translateSlide }}</span>
                </button>
              </div>
              <div
                class="hr_collapsed_slides"
                [@slideInOut]="showSlideMobile"
              >
                <div style="padding-top: 20px">
                  <lse-slide-image
                    [eventFolder]='eventFolder'
                    [languages]='languages'
                    [selectedLanguage]='eLangUsed'
                  ></lse-slide-image>
                </div>
                <div class="hr_dropdown_slides">
                  <div
                    class="hr_current_slide"
                    *ngIf="eStatus.slideflow && eStatus.phase !== 'post-live'"
                  >
                    <span
                      class="cur_slide_left"
                      [ngClass]="{
                        cur_slide_left_disabled: !this.slideIsCustom
                      }"
                    ></span>
                    <button
                      class="btn_current_slide"
                      [ngClass]="{
                        btn_current_slide_disabled: !this.slideIsCustom
                      }"
                      (click)="myReturnToLiveSlide()"
                    >
                      <span>{{ eLangGlob?.translateCurSlide }}</span>
                    </button>
                    <span
                      class="cur_slide_right"
                      [ngClass]="{
                        cur_slide_right_disabled: !this.slideIsCustom
                      }"
                    ></span>
                  </div>
                </div>
                <div
                  *ngIf="
                    (eStatus.slideflow && eStatus.phase !== 'post-live') ||
                    (eStatus.player && eStatus.phase === 'post-live' && eStatus.slideflow)
                  "
                  class="hr_collapsed_slides"
                >
                  <lse-slidelist
                    *ngIf="eStatus.slides && eStatus.slideflow"
                    (playAtEvent)="player.playAt($event)"
                    (showElement)="showElement('slides')"
                    [eventFolder]='eventFolder'
                    [phase]="eStatus.phase"
                    [eStatus]="eStatus"
                    [selectedLanguage]='eLangUsed'
                    [languages]='languages'
                    [eLangGlob]="eLangGlob"
                    [slideIsCustom]="slideIsCustom"
                    #slideHistoryChild
                  ></lse-slidelist>
                </div>
              </div>
            </div>
            <hr *ngIf="eStatus.slides" />
            <!-- UMFRAGEN (unsichtbar, solange keine Umfrage geöffnet wurde) -->
            <lse-user-poll
              *ngIf="eStatus.phase !== 'post-live' || pollStore.vodMode()"
              [eLangGlob]="eLangGlob"
            ></lse-user-poll>
            <lse-user-vote-question-list
              *ngIf="eStatus.user_see_questions && eStatus.phase !== 'post-live'"
              [pageSize]="+eSetup.vod_pageSize"
              [eStatus]="eStatus"
              (playAtEvent)="player.playAt($event)"
              [user_vote_questions]="!!eStatus.user_vote_questions"
            ></lse-user-vote-question-list>
            <lse-vod-question-list
              *ngIf="
                eStatus.user_ask_questions &&
                screenwidth > 512 &&
                eStatus.phase === 'post-live' &&
                eStatus.player
              "
              [pageSize]="+eSetup.vod_pageSize"
              [language]="activeLang()"
              (playAtEvent)="player.playAt($event)"
            ></lse-vod-question-list>
            <lse-vod-question-list
              *ngIf="
                eStatus.user_ask_questions &&
                screenwidth <= 512 &&
                eStatus.phase === 'post-live' &&
                eStatus.player
              "
              [pageSize]="1"
              (playAtEvent)="player.playAt($event)"
              [language]="activeLang()"
            ></lse-vod-question-list>
            <!-- UAQ -->
            <lse-user-ask-question
              *ngIf="(eStatus.user_ask_questions && screenwidth <= 1023) || eStatus.user_vote_questions"
            ></lse-user-ask-question>
            <!-- UAQ ENDE -->
          </div>
          <!-- MOBILE DIE RESTLICHEN KOMPONENTEN ENDE -->
        </div>
        <div
          *ngIf="screenwidth > 1023"
          class="middle two wide column"
        ></div>
        <!-- Laptopgröße und größer: ALLES AB 1023px -->
        <div
          *ngIf="screenwidth > 1023"
          class="right seven wide column"
        >
          <!-- VOD (Post Live)-->
          <div *ngIf="eStatus.phase === 'post-live'">
            <!-- UMFRAGEN IM VOD: an ihren Stellen im Video, ersetzt dann Folien und Fragen -->
            <lse-user-poll *ngIf="pollsTabActive()" mode="tab" [eLangGlob]="eLangGlob"></lse-user-poll>
            <!-- VOD QUESTION LISTE ODER SLIDE-->
            <div
              *ngIf="
                eStatus.isLive &&
                eStatus.user_ask_questions &&
                showQuestions &&
                !pollsTabActive() &&
                eStatus.phase === 'post-live' &&
                eStatus.player
              "
              class="box rightBox overflow"
            >
              <lse-vod-question-list
                [pageSize]="+eSetup.vod_pageSize"
                (playAtEvent)="player.playAt($event)"
                (questionCount)="questionCount($event)"
                [language]="activeLang()"
              ></lse-vod-question-list>
            </div>
            <!-- VOD QUESTION LISTE ENDE -->
            <!-- VOD SLIDE -->
            <div
              *ngIf="eStatus.isLive && eStatus.slides && showSlides && !pollsTabActive() && eStatus?.phase == 'post-live'"
            >
                <div class="box rightBox">
                  <lse-slide-image
                    [eventFolder]='eventFolder'
                    [languages]='languages'
                    [selectedLanguage]='eLangUsed'
                  ></lse-slide-image>
                </div>
                <lse-slidelist
                  *ngIf="eStatus.slides && eStatus.slideflow"
                  (playAtEvent)="player.playAt($event)"
                  (showElement)="showElement('slides')"
                  [eventFolder]='eventFolder'
                  [phase]="eStatus.phase"
                  [eStatus]="eStatus"
                  [languages]='languages'
                  [selectedLanguage]='eLangUsed'
                  [eLangGlob]="eLangGlob"
                  [slideIsCustom]="slideIsCustom"
                  #slideHistoryChild
                ></lse-slidelist>
              </div>
          </div>
          <!-- (PRE-)Live -->
          <div *ngIf="eStatus.phase !== 'post-live' && eStatus.isLive">
            <!-- UMFRAGEN: eigener Tab im Header, ersetzt dann Folien und Fragen -->
            <lse-user-poll *ngIf="pollsTabActive()" mode="tab" [eLangGlob]="eLangGlob"></lse-user-poll>
            <!-- ------------------------------------------------------------------------ -->
            <!-- RECHTE SEITE BEGINNEND MIT SLIDES -->
            <div *ngIf="eStatus.slides && showSlides && slideLoadComplete && !pollsTabActive()">
                <div class="box rightBox">
                  <lse-slide-image
                    [eventFolder]='eventFolder'
                    [languages]='languages'
                    [selectedLanguage]='eLangUsed'
                  ></lse-slide-image>
                </div>
                <lse-slidelist
                  *ngIf="eStatus.slides && eStatus.slideflow"
                  (playAtEvent)="player.playAt($event)"
                  (showElement)="showElement('slides')"
                  [eventFolder]='eventFolder'
                  [phase]="eStatus.phase"
                  [eStatus]="eStatus"
                  [selectedLanguage]='eLangUsed'
                  [languages]='languages'
                  [eLangGlob]="eLangGlob"
                  [slideIsCustom]="slideIsCustom"
                  #slideHistoryChild
                ></lse-slidelist>
              <!-- LIVE UAQ -->
              <lse-user-ask-question
                *ngIf="eStatus.user_ask_questions && !eStatus.user_vote_questions"
              ></lse-user-ask-question>
              <!-- LIVE UAQ ENDE -->
            </div>
            <!-- RECHTE SEITE BEGINNEND MIT SLIDES ENDE -->
            <!-- ------------------------------------------------------------------------ -->
            <!-- RECHTE SEITE BEGINNEND MIT UAQ -->
            <div *ngIf="eStatus.user_ask_questions && !eStatus.slides && !eStatus.user_see_questions && !pollsTabActive()">
              <div class="box rightBox">
                <lse-user-ask-question></lse-user-ask-question>
              </div>
            </div>
            <!-- RECHTE SEITE BEGINNEND MIT UAQ ENDE -->
            <!-- ------------------------------------------------------------------------ -->
            <!-- RECHTE SEITE BEGINNEND MIT UVQ -->
            <div *ngIf="eStatus.user_see_questions && showQuestions && !pollsTabActive()">
              <lse-user-vote-question-list
                [pageSize]="+eSetup.vod_pageSize"
                [eStatus]="eStatus"
                (playAtEvent)="player.playAt($event)"
                [user_vote_questions]="!!eStatus.user_vote_questions"
              ></lse-user-vote-question-list>
            </div>
            <!-- RECHTE SEITE BEGINNEND MIT UVQ ENDE -->
          </div>
        </div>
      </div>
    </div>

    <ng-template #waittext>
      <div [@inOutAnimation]>
        <div
          class=""
          style="width: 780px; height: 440px; background-color: #3ed8c3; text-align: center"
        >
          <h3
            *ngIf="eStatus.use_postlive_txt"
            style="vertical-align: middle; line-height: 440px"
          >
            {{ eConfig.postlive_txt }}
          </h3>
          <h3
            *ngIf="!eStatus.use_postlive_txt"
            style="vertical-align: middle; line-height: 440px"
          >
            {{ eConfig.waiting_txt }}
          </h3>
        </div>
      </div>
    </ng-template>
  </div>

</div>
